import { isPlatformServer } from '@angular/common';
import { inject, Injectable, PLATFORM_ID, SecurityContext, ɵunwrapSafeValue as unwrapSafeValue } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
    providedIn: 'root'
})
export class SanitizeHtmlService {
    private readonly platformId = inject(PLATFORM_ID);
    private readonly domSanitizer = inject(DomSanitizer);

    html(inputHtml: string): string {
        // Parse the HTML string into a DOM structure
        if (isPlatformServer(this.platformId)) {
            if (/(script|link|style)/.test(inputHtml)) {
                return unwrapSafeValue(this.domSanitizer.sanitize(SecurityContext.HTML, inputHtml) ?? '');
            }

            return unwrapSafeValue(this.domSanitizer.bypassSecurityTrustHtml(inputHtml));
        }

        let doc: HTMLElement | null = null;

        const parser = new DOMParser();
        doc = parser.parseFromString(inputHtml, 'text/html').body;

        if (!doc) {
            return '';
        }

        // Tags to remove
        ['style', 'script', 'html', 'body', 'head', 'link'].forEach(tag => {
            const elements = doc.querySelectorAll(tag);
            elements.forEach(el => el.remove());
        });

        // Remove JavaScript-related attributes (e.g., onload, onclick)
        const elements = doc.querySelectorAll('*');
        elements?.forEach(element => {
            Array.from(element.attributes).forEach(attr => {
                if (attr.name.startsWith('on')) {
                    element.removeAttribute(attr.name);
                }
            });
        });

        return doc.innerHTML;
    }
}
